import DEFAULT_VALUES_LAYER from '../default'

const { page: DEFAULT_PAGE_LAYER, ...rest } = DEFAULT_VALUES_LAYER

export default {
  videoCallSchedulingSuccess: {
    ...rest,
    page: {
      ...DEFAULT_PAGE_LAYER,
      pageType: 'agendamento-videochamada-sucesso',
      pageName: '/webmotors/comprar/detalhe/videochamada/sucesso',
      pageNameTier2: 'videochamada',
      pageNameTier3: 'sucesso',
    },
  },
}
